import { SiteType } from '@treadinc/horizon-api-spec';
import { t } from 'i18next';
import { noop } from 'lodash-es';
import { useCallback } from 'react';

import { InfiniteQuery, InfiniteQueryOption } from './constants';

const data: InfiniteQueryOption[] = Object.values(SiteType)
  .filter((type) => type !== SiteType.EQUIPMENT_HOME_BASE)
  .map((type) => ({ label: t(`site_types.${type}`), value: `${type}` }));

export default function useSiteTypesInfiniteQuery(): InfiniteQuery {
  const noopFn = useCallback(() => {
    return noop;
  }, []);

  return {
    clear: noopFn,
    data,
    fetch: noopFn,
    fetchMore: undefined,
    isDummyQuery: true,
  };
}
